import React from 'react'
import { formatNumber, unformatNumber } from '../lib/currency-formatter'

export interface Props {
  placeholder: string
  valueInitial: number
  value: number
  step: number
  precision: number
  // enabled: boolean;
  // units: string[];
  setValue: (value: number, hold?: boolean) => void
  calcValue: (value: number) => number
  onInputValid: (inputValid: boolean) => void
  valueChanged?: (value: number) => void
  max?: number
  min?: number
}

export interface State {
  value: string
  valueIncorrect: boolean
  interval?: any
}

class NumberInput extends React.Component<Props, State> {
  private interval: any = null
  private holdDelay: number = 100
  private countUp: number = 10 // increase step each second (holdDelay*countUp)

  constructor(props: Props) {
    super(props)

    this.inputValue = this.inputValue.bind(this)
    this.unformatValue = this.unformatValue.bind(this)
    this.incDecValue = this.incDecValue.bind(this)
    this.incDecHold = this.incDecHold.bind(this)
    this.handleUserInput = this.handleUserInput.bind(this)

    this.state = {
      value: this.props.value
        ? formatNumber(this.props.value, this.props.precision)
        : formatNumber(this.props.valueInitial, this.props.precision),
      valueIncorrect: false,
    }
  }

  public render() {
    return (
      // <div className={"counter-group__item justify-content-between "+(enabled?"":"disabled")}>
      <div className="counter-group__item justify-content-between NumberInput">
        <button
          disabled={this.isDecrementButtonDisabled('decrement')}
          onMouseDown={() => {
            this.incDecHold(true)
          }}
          onMouseUp={() => {
            this.incDecHold(false)
          }}
          onMouseLeave={() => {
            this.incDecHold(false)
          }}
          className="btn counter-group__btn counter-group__btn--decrease"
          data-cy={'decrease-' + this.props.placeholder.replace(/ /g, '')}
        >
          <i className="icon-minus" />
        </button>
        <input
          onChange={e => this.inputValue(e.target.value)}
          onFocus={e => this.unformatValue(e.target.value)}
          onBlur={this.handleUserInput}
          placeholder={this.props.placeholder}
          value={this.state.value}
          type="text"
          className={`counter-group__input ${this.state.valueIncorrect ? 'valueIncorrect' : ''}`}
          data-cy={this.props.placeholder.replace(/ /g, '')}
        />
        <button
          disabled={this.isDecrementButtonDisabled('increment')}
          onMouseDown={() => {
            this.incDecHold(true, true)
          }}
          onMouseUp={() => {
            this.incDecHold(false)
          }}
          onMouseLeave={() => {
            this.incDecHold(false)
          }}
          className="btn counter-group__btn counter-group__btn--increase"
          data-cy={'increase-' + this.props.placeholder.replace(/ /g, '')}
        >
          <i className="icon-plus" />
        </button>
      </div>
    )
  }

  public componentDidUpdate(prevProps: Props, prevState: State) {
    const { onInputValid } = this.props
    if (this.props.value && prevProps.value !== this.props.value) {
      onInputValid(true)
      this.setState(prev => ({
        value: formatNumber(this.props.value, this.props.precision),
        valueIncorrect: false,
      }))
    }
  }

  private isDecrementButtonDisabled(type: 'increment' | 'decrement') {
    return type === 'decrement'
      ? !!(
          this.props.min && this.props.min >= unformatNumber(this.state.value, this.props.precision)
        )
      : !!(
          this.props.max && this.props.max <= unformatNumber(this.state.value, this.props.precision)
        )
  }

  private incDecValue(step: number, increment?: boolean) {
    const { precision, setValue, calcValue, onInputValid } = this.props
    const newValue = increment
      ? calcValue(unformatNumber(this.state.value, precision) + step)
      : calcValue(unformatNumber(this.state.value, precision) - step)
    setValue(newValue, true)
    onInputValid(true)
    this.setState(otherState => ({
      value: formatNumber(newValue, precision),
      valueIncorrect: false,
    }))
  }

  private incDecHold(holdOn: boolean, increment?: boolean) {
    let step = this.props.step
    let count = 0
    clearInterval(this.interval)
    if (holdOn) {
      this.incDecValue(step, increment)
      this.interval = setInterval(() => {
        if (!this.isDecrementButtonDisabled(increment ? 'increment' : 'decrement')) {
          count = count + 1
          if (count % this.countUp === 0) {
            step = step * 2
          }
          this.incDecValue(step, increment)
        } else {
          clearInterval(this.interval)
        }
      }, this.holdDelay)
    }
  }

  private handleUserInput() {
    const { precision, valueInitial, calcValue, setValue, onInputValid } = this.props
    onInputValid(true)
    if (!this.state.value) {
      this.props.setValue(valueInitial)
      this.setState(prevState => ({
        value: formatNumber(valueInitial, precision),
        valueIncorrect: false,
      }))
    } else {
      const newValue = calcValue(unformatNumber(this.state.value, precision))
      setValue(newValue)
      this.setState(prevState => ({
        value: formatNumber(newValue, precision),
        valueIncorrect: false,
      }))
    }
  }

  private unformatValue(value: string) {
    this.setState(prevState => ({
      value: unformatNumber(value, this.props.precision).toFixed(this.props.precision),
    }))
  }

  private inputValue(value: string) {
    if (/^[+]?(\d+|\d+[.]?\d*)?$/.test(value)) {
      const { calcValue, onInputValid, valueChanged } = this.props
      const numValue = parseFloat(value)
      const valueIncorrect = calcValue(numValue) !== numValue
      onInputValid(!valueIncorrect)
      this.setState(prevState => ({
        value,
        valueIncorrect,
      }))
      valueChanged && valueChanged(numValue)
    }
  }
}

export default NumberInput
